import get from 'lodash/get';

import type { StorageClassOptionItem } from './types';

export function mapStorageClassItems(items: unknown[], filterProvisioner?: string): StorageClassOptionItem[] {
  if (!Array.isArray(items) || !items.length) return [];
  const filteredItems = filterProvisioner ? items.filter((item) => get(item, 'spec.provisioner') !== filterProvisioner) : items;
  return filteredItems.map((item) => ({
    label: get(item, 'spec.alias') || get(item, 'metadata.name'),
    value: get(item, 'metadata.name'),
    provisioner: get(item, 'spec.provisioner'),
    description: get(item, 'spec.description', '-'),
  }));
}

/** Select options.extra：下拉 label 为 JSX 时写入 optionMeta 展示名 */
export function buildStorageClassSelectExtra(opt: StorageClassOptionItem): Record<string, string | undefined> {
  return {
    name: opt.label,
    label: opt.label,
    description: opt.description,
    provisioner: opt.provisioner,
  };
}

/**
 * deliveryMetadata 提交用 storageClass：
 * 计价场景优先 pricing.deviceID，避免把 vendor/device 展示名写入 storageClassName。
 */
export function resolveStorageClassSubmitValue(
  storageClass?: string,
  pricing?: { deviceID?: string; deviceId?: string } | null,
): string | undefined {
  const fromPricing = String(pricing?.deviceID ?? pricing?.deviceId ?? '').trim();
  if (fromPricing) return fromPricing;
  const fromField = String(storageClass ?? '').trim();
  return fromField || undefined;
}
